import types from '../constants/ResourceReactionActionTypes';
import {
  createItemFail,
  createItemSuccess,
  removeItemFail,
  removeItemSuccess,
  updateItemFail,
  updateItemSuccess,
} from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function resourceReactions(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_RESOURCE_REACTION_SUCCESS:
      return createItemSuccess(state, action);
    case types.CREATE_RESOURCE_REACTION_FAIL:
      return createItemFail(state, action);

    case types.UPDATE_RESOURCE_REACTION_SUCCESS:
      return updateItemSuccess(state, action);
    case types.UPDATE_RESOURCE_REACTION_FAIL:
      return updateItemFail(state, action);

    case types.DELETE_RESOURCE_REACTION_SUCCESS:
      return removeItemSuccess(state, action);
    case types.DELETE_RESOURCE_REACTION_FAIL:
      return removeItemFail(state, action);

    default:
      return state;
  }
}
